<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="sd/so/getProductInfo">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="开始时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="订单号">
            <el-input v-model.trim="filter.techParamBillNO" clearable/>
          </vm-search>
          <vm-search label="客户合同号">
            <el-input v-model.trim="filter.clientContractNO" clearable/>
          </vm-search>
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="类型">
            <el-select v-model.trim="filter.itemType" style="width: 150px" clearable placeholder="请选择">
              <el-option :value="8" label="包装图片"/>
              <el-option :value="11" label="工单照片"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="techParamBillNO" width="200px" align="center" label="订单号"/>
      <el-table-column prop="clientContractNO" align="center" label="客户合同号"/>
      <el-table-column prop="materialNo" align="center" label="物料号"/>
      <el-table-column prop="materialDescription" width="250px" align="center" label="物料描述"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column prop="itemType" align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.itemType === '8'">
            包装图片
          </span>
          <span v-else>
            工单照片
          </span>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="filePath" align="center" label="路径"/>-->
      <el-table-column label="图片" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleDownload(scope.row)">查看图片</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";

  export default {
    name: "ProductInfoList",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          techParamBillNO: "",
          clientContractNO: "",
          materialNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          itemType: 11,
        },
      };
    },
    mounted() {
      this.initTime();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      initTime() {
        this.filter.endCreateTime = this.getFormatDate(new Date());
        this.filter.beginCreateTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        this.$refs.vmTable.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      handleDownload(row) {
        console.log(row);
        if(row.itemType === '8'){
          window.open(window.config.fileServerUrl +"/ShippingMarkImages/"+ row.filePath);
        }else {
          window.open(window.config.fileServerUrl +"/ProductionImages/"+ row.filePath);
        }
      },
    },
  };
</script>

<style scoped>

</style>
